export const API_HOST = 'https://api5.ruptly.tv';
export const VOD_HOST = 'https://staging.ruptly.tv';
export const LIVE_HOST = 'https://staging.ruptly.tv';
export const STATIC_HOST = 'https://video.ruptly.tv';
export const STRIPE_API_KEY = 'pk_test_lDwsCASDrdL3ZKq9MqsFAuCD';
export const WS_URI = 'wss://api5.ruptly.tv/cable';
export const COMMON_DOMAIN = '.ruptly.tv';
export const PLAUSIBLE_SCRIPT_PATH = 's3.eu-west-1.amazonaws.com/vodstorage.ruptly.online';
